module.exports = __webpack_public_path__ + "img/sv6.16658aad.svg";